import React from "react";
import "./CokeOvenDragChain.css";

const CokeOvenDragChain = () => {
  return (
    <div className="main-coke">
      <div className="second-coke">
        <div className="coke">
          <p>Coke Oven Drag Chain</p>
          <div>
            <p className="coke2">
              Swajit Engineering Pvt.Ltd.> Coke Oven Drag Chain
            </p>
          </div>
        </div>
        <div className="cokeoven">
          <h3>
            Coke Oven Drag Chain Manufacturers In India for Bulk Handling
            Applications
          </h3>
          <p>
            We at Swajit engineering Pvt ltd are leading one of the{" "}
            <b>
              {" "}
              coke oven drag chain Manufacturers in Aurangabad, Maharashtra
              India.
            </b>{" "}
            With our skilled and dynamic team of professionals, we are involved
            in manufacturing and providing larger-scale coke oven drag chains
            for various bulk handling applications.
          </p>
          <p>
            Drag conveyor chains are widely used for conveying a wide range of
            materials which include ash, zinc, coal, limestone, biomass,
            petroleum coke, and other materials. Our conveyor chains are widely
            demanded amongst the customers due to their different uses and
            features and as it conveys heavy duty as well as difficult
            materials. It is mostly used to convey hot coal to the oven and many
            other suitable applications. Our premium quality drag conveyor
            chains and systems help you to improve your work efficiency and
            productivity by saving lots of time.
          </p>
          <p>
            We are offering a coke oven drag chain that is utilized to transfer
            heavy materials in power plants, paper & pulp, energy plants, steel
            industry, automotive industry, and oil & gas industry. They are
            highly durable, wear & tear resistance, dust-free, and
            corrosion-resistant. Owing to given properties, our company has its
            own reputation and name in the market, even considered as the best{" "}
            <b>Coke Oven Drag Chain Manufacturers in India.</b>
          </p>
          <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
        </div>
      </div>
    </div>
  );
};

export default CokeOvenDragChain;
